import Titles from '../components/Titles/Titles';
import SitemapLinks from '../components/Sitemap/SitemapLinks/SitemapLinks';
import Make from './../components/MakeSection/Make';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const Sitemap = () => {
    const seo = usePageSEO('sitemap');

    return (
        <>
            <SEO
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
                type={seo.type}
                noIndex={seo.noIndex}
                noFollow={seo.noFollow}
            />
            <Titles pageType="sitemap" />
            <SitemapLinks />
            <Make pageKey='SitemapPage' />
        </>
    );
};

export default Sitemap;